import { render, staticRenderFns } from "./paperAnalysis.vue?vue&type=template&id=3243208b&scoped=true"
import script from "./paperAnalysis.vue?vue&type=script&lang=js"
export * from "./paperAnalysis.vue?vue&type=script&lang=js"
import style0 from "./paperAnalysis.vue?vue&type=style&index=0&id=3243208b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3243208b",
  null
  
)

export default component.exports